// es6 polyfills
import './util/polyfill';
// register ambient and the states used by the sidekick
import './ambient/ambient';
import './ambient/ambient-height';
import './ambient/ambient-width';
// init ambient states
import './ambient/ambient-config-states';

import init from './init';
import cycle from './cmpt/index';
import * as store from './util/store';
import * as events from './util/event-bus';
import * as dom from './util/easy-dom';
import audioeye from './audioeye';
import * as cache from './util/persistence';
import startPendo from './util/pendo-helpers';
import { loadPendo, pendoApi } from './pendo';
import { taskApi } from './interface/TaskInterface';

const _win = (0, eval)('this'); // eslint-disable-line no-eval

/////
// register the global sidekick object
//
if (_win.sidekick !== undefined) {
	console && console.error && console.error('TOO MANY SIDEKICKS => the sidekick was loaded twice on this page.'); // eslint-disable-line
}
_win.sidekick = _win.sidekick || {
	init, cycle, dom, audioeye,
	store: store.publicApi,
	events: events.publicApi,
	cache: cache.publicApi,
	startPendo,
	loadPendo,
	pendo: pendoApi,
	task: taskApi
};

// Temporary deploy test log — remove after verification
/* eslint-disable no-console */
if (console && console.log) {
	console.log('[DEPLOY-TEST] latest sidekick loaded (delta2) at ' + new Date().toISOString());
}
/* eslint-enable no-console */
